// Light and dark theme

export const light = {
  body: "#fff",
  text: "#202020",

  primary: "#0f9e90",
  secondary: "#363557",

  bodyRgba: "255, 255, 255",
  textRgba: "32, 32, 32",

  grey: "#f7f7f7",

  fontxs: "0.75em",
  fontsm: "0.875em",
  fontmd: "1em",
  fontlg: "1.25em",
  fontxl: "2em",
  fontxxl: "3em",
  fontxxxl: "4em",

  fontButton: "0.875em",

  navHeight: "7rem",
};

export const dark = {
  body: "#202020",
  text: "#fff",

  primary: "#0f9e90",
  secondary: "#363557",

  bodyRbga: "32, 32, 32",
  textRbga: "255, 255, 255",

  carouselColor: "#EEEDDE",

  grey: "#f7f7f7",

  // 1em = 16px
  fontxs: "0.75em",
  fontsm: "0.875em",
  fontmd: "1em",
  fontlg: "1.25em",
  fontxl: "2em",
  fontxxl: "3em",
  fontxxxl: "4em",

  fontButton: "0.875em",

  navHeight: "7rem",
};
